module.exports = {
    isCarrierWithSmallBagInCabin: function(carrierCode) {
        return Odigeo._.includes(Odigeo.CONFIG.carriersWithSmallBagInCabin.split(',').map((item) => item.trim()), carrierCode);
    },
};
